import React from "react";
import arrowright from "../Images/Icones/arrowright.svg";
import "./Styles/oneRowNavigation.css"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
export default class OneRowNavigation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          subs: []
        };
    }

    showSubMenu = (e) => {

        let allSubmenus = document.getElementsByClassName('subMenu')
        let elem = e.currentTarget;
        let subMenu = elem.nextSibling;
        let isActive = subMenu.classList.contains('active') ? true : false;
                 
        for (let i = 0; i < allSubmenus.length; i++) {
            if(allSubmenus[i].classList.contains('active')){
                allSubmenus[i].classList.remove('active')
            }
        }

        if(!isActive){
            subMenu.classList.add('active');
        }
    }

    componentDidMount(){
        let subs = [];

        this.props.subs.map((x, i) => {
            subs.push(<li key={'subMenu'+x.id+'_'+x.parent.id}><a href={"/boutique?category="+x.slug}>{x.name}</a></li>)
        })

        this.setState({
            subs: subs
        });
    }

    render() {
        return (
            <ul>
                <li onClick={((e) => this.showSubMenu(e))} className="nav-link flexcenter">
                    <a style={{paddingLeft: '8px',justifyContent: 'unset'}} href="#" onClick={(e)=>{e.preventDefault()}} className="flexcenter">
                        <img src={this.props.img} alt="icon" />
                        <span> {this.props.label}</span>
                    </a>
                    <KeyboardArrowRightIcon sx={{color: "white"}} />
                </li>
                <div className="subMenu">
                    <ul>
                        {this.state.subs}
                    </ul>
                </div>

            </ul>
        )
    }
}

